/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_ProteinInputs */

const en_us2_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein`)
};

const pt_br2_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína`)
};

const es_419_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína`)
};

const pt_pt2_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína`)
};

const fr_fr2_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protéines`)
};

const de_de2_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein`)
};

const it_it2_search_field_protein = /** @type {(inputs: Search_Field_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteine`)
};

/**
* | output |
* | --- |
* | "Protein" |
*
* @param {Search_Field_ProteinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_protein = /** @type {((inputs?: Search_Field_ProteinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_ProteinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_protein(inputs)
	if (locale === "es-419") return es_419_search_field_protein(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_protein(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_protein(inputs)
	if (locale === "de-DE") return de_de2_search_field_protein(inputs)
	if (locale === "it-IT") return it_it2_search_field_protein(inputs)
	return en_us2_search_field_protein(inputs)
});
export { search_field_protein as "search.field_protein" }